import Main from '@/view/main.vue';
import Print from '@/view/print.vue';

export const homeRouter = [{
    path: '/',
    name: 'login',
    component: () =>
        import('@/view/login.vue')
},
{
    path: '/print',
    name: 'print',
    component: Print,
    children: [{
        path: 'certificate',
        name: 'certificate',
        component: () =>
            import('@/view/information/control/print.vue')
    },
    {
        path: 'batchPrint',
        name: 'batchPrint',
        component: () =>
            import('@/view/information/control/batchPrint.vue')
    },
    //学组工作站下的打印
    {
        path: 'wokeler',
        name: 'wokeler',
        component: () =>
            import('@/view/information/control/wokeler.vue')
    },
    {
        path: 'pintissue',
        name: 'pintissue',
        component: () =>
            import('@/view/information/control/pintissue.vue')
    },
    ]
},
{
    path: 'BigBI',
    icon: 'paperclip',
    name: 'BigBI',
    title: '统计BI',
    component: () =>
        import('@/view/Statistics/Bi.vue')
},
// 官网下面的信息增加和删除
{
    path: '/info',
    name: 'info',
    component: Main,
    children: [{
        path: 'operate',
        name: 'operate',
        component: () =>
            import('@/view/officeWebsite/child/operate.vue')
    }]
},
// 会员管理下面的委员会
{
    path: '/vip',
    name: 'vip',
    component: Main,
    children: [{
        path: 'com',
        name: 'com',
        component: () =>
            import('@/view/information/child/vipCom.vue')
    },
    {
        path: 'activevip',
        name: 'activevip',
        component: () =>
            import('@/view/information/child/activeVip.vue')
    }
    ]
},
// 视频管理下面的数据统计
{
    path: '/videoStatistics',
    name: 'videoStatistics',
    component: Main,
    children: [{
        path: 'videoStatistics',
        name: 'videoStatistics',
        component: () =>
            import('@/view/information/child/videoStatistics.vue')
    }]
},
// 会员单位管理编辑
{
    path: '/vipUnit',
    name: 'vipUnit',
    component: Main,
    children: [{
        path: 'editor',
        name: 'editor',
        component: () =>
            import('@/view/information/control/vipUnit.vue')
    }]
},
//  学组下的医生
{
    path: '/doctorlist',
    name: 'doctorlist',
    component: Main,
    children: [{
        path: 'doctor',
        name: 'doctor',
        component: () =>
            import('@/view/information/child/docListLer.vue')
    }]
},
//  委员会下面的医生列表
{
    path: '/doclistcom',
    name: 'doclistcom',
    component: Main,
    children: [{
        path: 'doc',
        name: 'doc',
        component: () =>
            import('@/view/information/child/docListCom.vue')
    },
    {
        path: 'learn',
        name: 'learn',
        component: () =>
            import('@/view/information/child/lerTeamCom.vue')
    },
    {
        path: 'work',
        name: 'work',
        component: () =>
            import('@/view/information/child/workSitCom.vue')
    },
    {
        path: 'activecom',
        name: 'activecom',
        component: () =>
            import('@/view/information/child/activeCom.vue')
    },
    {
        path: 'transition',
        name: 'transition',
        component: () =>
            import('@/view/information/child/transition.vue')
    },
    {
        path: 'printlist',
        name: 'printlist',
        component: () =>
            import('@/view/information/child/printlist.vue'),
        meta: { keepAlive: true }

    },
    {
        path: 'transitionDetail',
        name: 'transitionDetail',
        component: () =>
            import('@/view/information/child/transitionDetail.vue')
    },
    {
        path: 'transitionDetails',
        name: 'transitionDetails',
        component: () =>
            import('@/view/information/child/transitionDetails.vue')
    },
    ]
},
// 工作站下面的医生
{
    path: '/doclistwrk',
    name: 'doclistwrk',
    component: Main,
    children: [{
        path: 'site',
        name: 'site',
        component: () =>
            import('@/view/information/child/docListWok.vue')
    }]
},
// 信息管理下面的活动管理
{
    path: '/active',
    name: 'active',
    component: Main,
    children: [{
        path: 'control',
        name: 'control',
        component: () =>
            import('@/view/information/control/operate.vue')
    },]
},
// 会议的参与人员
{
    path: '/meet',
    name: 'meet',
    component: Main,
    children: [{
        path: 'join',
        name: 'join',
        component: () =>
            import('@/view/signOnMeet/child/personMet.vue')
    },
    {
        path: 'seats',
        name: 'seats',
        component: () =>
            import('@/view/signOnMeet/child/seatsManage.vue')
    }
    ]
},
//医院下面的科室管理
{
    path: '/office',
    name: 'office',
    component: Main,
    children: [{
        path: 'officeAdmin',
        name: 'officeAdmin',
        component: () =>
            import('@/view/information/child/officeAdmin.vue')
    },
    {
        path: 'magazine',
        name: 'magazine',
        component: () =>
            import('@/view/information/child/magazine.vue')
    },
    {
        path: 'issue',
        name: 'issue',
        component: () =>
            import('@/view/information/child/issue.vue')
    }
    ]
},
//会议管理
{
    path: '/live',
    name: 'live',
    component: Main,
    children: [{
        path: 'liveDetail',
        name: 'liveDetail',
        component: () =>
            import('@/view/signOnMeet/child/liveDetail.vue')
    }]
},
//委员预注册委员照片导出功能
{
    path: '/photographPDF',
    name: 'photographPDF',
    component: Print,
    children: [{
        path: 'pgPDF',
        name: 'pgPDF',
        component: () =>
            import('@/view/information/photographPDF.vue')
    }]
},
{
    path: '/signaturePDF',
    name: 'signaturePDF',
    component: Print,
    children: [{
        path: 'signaturePDF',
        name: 'signaturePDF',
        component: () =>
            import('@/view/information/child/signaturePDF.vue')
    }]
},
{
    path: '/signPDF',
    name: 'signPDF',
    component: Print,
    children: [{
        path: 'signPDF',
        name: 'signPDF',
        component: () =>
            import('@/view/information/child/signPDF.vue')
    }]
},
{
    path: '/batchPDF',
    name: 'batchPDF',
    component: Print,
    children: [{
        path: 'batchPDF',
        name: 'batchPDF',
        component: () =>
            import('@/view/information/child/batchPDF.vue')
    }]
}
];

export const appRouter = [
    {
        path: '/home',
        name: 'home',
        icon: 'ios-rose',
        title: '首页',
        component: Main,
        children: [{
            path: 'homepage',
            icon: 'paperclip',
            name: 'homepage',
            title: '首页',
            component: () =>
                import('@/view/home.vue')
        }]
    },
    {
        path: '/CustomerManagement',
        name: 'CustomerManagement',
        icon: 'ios-rose',
        title: '客户管理',
        component: Main,
        children: [
            {
                path: 'CustomerList',
                icon: 'paperclip',
                name: 'CustomerList',
                title: '客户管理',
                component: () => import('@/view/CustomerManagement/CustomerList.vue')
            }
        ]
    },
    {
        path: '/officeWebsite',
        name: 'officeWebsite',
        icon: 'folder',
        title: '官网管理',
        component: Main,
        children: [{
            path: 'columnList',
            icon: 'paperclip',
            name: 'columnList',
            title: '栏目列表',
            component: () =>
                import('@/view/officeWebsite/columnList.vue')
        },
        {
            path: 'columnInfo',
            icon: 'paperclip',
            name: 'columnInfo',
            title: '栏目信息',
            component: () =>
                import('@/view/officeWebsite/columnInfo.vue')
        },
        {
            path: 'checkNews',
            icon: 'paperclip',
            name: 'checkNews',
            title: '新闻审核',
            component: () =>
                import('@/view/officeWebsite/checkNews.vue')
        },
        {
            path: 'friendLink',
            icon: 'paperclip',
            name: 'friendLink',
            title: '友情链接',
            component: () =>
                import('@/view/officeWebsite/friendlyLink.vue')
        },
        {
            path: 'inform',
            icon: 'paperclip',
            name: 'inform',
            title: '通知管理',
            component: () =>
                import('@/view/officeWebsite/inform.vue')
        },
        {
            path: 'feedback',
            icon: 'paperclip',
            name: 'feedback',
            title: '委员反馈',
            component: () =>
                import('@/view/officeWebsite/feedback.vue')
        },
        {
            path: 'mistake',
            icon: 'paperclip',
            name: 'mistake',
            title: '网站报错',
            component: () =>
                import('@/view/officeWebsite/mistake.vue')
        },
        {
            path: 'ThinkTankExpertManagement',
            icon: 'paperclip',
            name: 'ThinkTankExpertManagement',
            title: '智库专家管理',
            component: () =>
                import('@/view/officeWebsite/ThinkTankExpertManagement.vue')
        },
        {
            path: 'CouncilManagement',
            icon: 'paperclip',
            name: 'CouncilManagement',
            title: '理事会管理',
            component: () =>
                import('@/view/officeWebsite/CouncilManagement.vue')
        }
            // ,
            // {
            //     path: 'mistake',
            //     icon: 'paperclip',
            //     name: 'mistake',
            //     title: '智库专家管理',
            //     component: () =>
            //         import ('@/view/officeWebsite/mistake.vue')
            // }
        ]
    },
    {
        path: '/information',
        name: 'information',
        icon: 'folder',
        title: '信息管理',
        component: Main,
        children: [
            {
                path: 'docArticle',
                name: 'docArticle',
                component: () =>
                    import('@/view/information/docArticle.vue'),
            },
            {
                path: 'vipAdmin',
                icon: 'paperclip',
                name: 'vipAdmin',
                title: '会员管理',
                component: () =>
                    import('@/view/information/vipAdmin.vue'),
            },
            // {
            //     path: 'aheadVip',
            //     icon: 'paperclip',
            //     name: 'aheadVip',
            //     title: '委员预注册',
            //     component: () =>
            //         import ('@/view/information/aheadVip.vue'),
            //     meta: { keepAlive: true }
            // },
            {
                path: 'unitaheadVip',
                icon: 'paperclip',
                name: 'unitaheadVip',
                title: '单位会员预注册',
                component: () =>
                    import('@/view/information/unitaheadVip.vue')
            },
            {
                path: 'newAheadVip',
                icon: 'paperclip',
                name: 'newAheadVip',
                title: '委员预注册',
                component: () =>
                    import('@/view/information/newAheadVip.vue'),
                meta: { keepAlive: true }
            },
            // {
            //     path: 'Recommender',
            //     icon: 'paperclip',
            //     name: 'Recommender',
            //     title: '推荐人管理',
            //     component: () =>
            //         import('@/view/information/Recommender2.vue'),
            //     meta: { keepAlive: true }
            // },
            // {
            //     path: 'Recommenders',
            //     icon: 'paperclip',
            //     name: 'Recommenders',
            //     title: '推荐人管理02',
            //     component: () =>
            //         import('@/view/information/Recommender3.vue'),
            //     meta: { keepAlive: true }
            // },
            {
                path: 'SealAudit',
                icon: 'paperclip',
                name: 'SealAudit',
                title: '盖章表管理',
                component: () =>
                    import('@/view/information/sealAudit.vue'),
                meta: { keepAlive: true }
            },
            {
                path: 'vipUnitAdmin',
                icon: 'paperclip',
                name: 'vipUnitAdmin',
                title: '单位会员管理',
                component: () =>
                    import('@/view/information/vipUnitAdmin.vue')
            },
            {
                path: 'childvipUnitAdmin',
                icon: 'paperclip',
                name: 'childvipUnitAdmin',
                title: '单位会员管理-财务',
                component: () =>
                    import('@/view/information/childvipUnitAdmin.vue')
            },
            {
                path: 'specialCommitAdmin',
                icon: 'paperclip',
                name: 'specialCommitAdmin',
                title: '专业委员会管理',
                component: () =>
                    import('@/view/information/specialCommitAdmin.vue')
            },
            {
                path: 'listofdoctors',
                icon: 'paperclip',
                name: 'listofdoctors',
                title: '医生列表',
                component: () =>
                    import('@/view/information/ListOfDoctors.vue')
            },
            {
                path: 'application',
                icon: 'paperclip',
                name: 'application',
                title: '退出申请管理',
                component: () =>
                    import('@/view/information/application.vue')
            },
            {
                path: 'learnTeamAdmin',
                icon: 'paperclip',
                name: 'learnTeamAdmin',
                title: '学组管理',
                component: () =>
                    import('@/view/information/learnTeamAdmin.vue')
            },
            {
                path: 'workSiteAdmin',
                icon: 'paperclip',
                name: 'workSiteAdmin',
                title: '协作团队管理',
                component: () =>
                    import('@/view/information/workSiteAdmin.vue')
            },

            {
                path: 'activityAdmin',
                icon: 'paperclip',
                name: 'activityAdmin',
                title: '活动管理',
                component: () =>
                    import('@/view/information/activityAdmin.vue')
            },
            {
                path: 'payAdmin',
                icon: 'paperclip',
                name: 'payAdmin',
                title: '缴费项目',
                component: () =>
                    import('@/view/information/payAdmin.vue')
            },
            {
                path: 'ServicesUnit',
                icon: 'paperclip',
                name: 'ServicesUnit',
                title: '单位服务项目',
                component: () =>
                    import('@/view/information/ServicesUnit.vue')
            },
            {
                path: 'payfeeAdmin',
                icon: 'paperclip',
                name: 'payfeeAdmin',
                title: '缴费记录-委员',
                component: () =>
                    import('@/view/information/payfeeAdmin.vue')
            },
            {
                path: 'payfeeUnit',
                icon: 'paperclip',
                name: 'payfeeUnit',
                title: '缴费记录-单位',
                component: () =>
                    import('@/view/information/payfeeUnit.vue')
            },
            {
                path: 'bookPay',
                icon: 'paperclip',
                name: 'bookPay',
                title: '工本费记录',
                component: () =>
                    import('@/view/information/bookFee.vue')
            },
            {
                path: 'videoAdmin',
                icon: 'paperclip',
                name: 'videoAdmin',
                title: '视频管理',
                component: () =>
                    import('@/view/information/videoAdmin.vue')
            },
            {
                path: 'titleAdmin',
                icon: 'paperclip',
                name: 'titleAdmin',
                title: '委员会职位管理',
                component: () =>
                    import('@/view/information/titleAdmin.vue')
            },
            {
                path: 'hospitalAdmin',
                icon: 'paperclip',
                name: 'hospitalAdmin',
                title: '医院发行管理',
                component: () =>
                    import('@/view/information/hospitalAdmin.vue')
            },
            {
                path: 'readFile',
                icon: 'paperclip',
                name: 'readFile',
                title: '数据表上传',
                component: () =>
                    import('@/view/information/readFile.vue')
            },
            {
                path: 'vote',
                icon: 'paperclip',
                name: 'vote',
                title: '投票管理',
                component: () =>
                    import('@/view/information/vote.vue')
            },
            // {
            //     path: 'paycostreport',
            //     icon: 'paperclip',
            //     name: 'paycostreport',
            //     title: '缴费报表统计',
            //     component: () =>
            //         import('@/view/information/paycostreport.vue')
            // },
            {
                path: 'ImgAdmin',
                icon: 'paperclip',
                name: 'ImgAdmin',
                title: '图片管理',
                component: () =>
                    import('@/view/information/ImgAdmin')
            },
            {
                path: 'infoadmin',
                icon: 'paperclip',
                name: 'infoadmin',
                title: '短信管理',
                component: () =>
                    import('@/view/information/infoadmin.vue'),
            },
        ]
    },
    {
        path: '/signOnMeet',
        name: 'signOnMeet',
        icon: 'folder',
        title: '会务管理',
        component: Main,
        children: [{
            path: 'meetList',
            icon: 'paperclip',
            name: 'meetList',
            title: '会议登记',
            component: () =>
                import('@/view/signOnMeet/meetList.vue')
        },
        {
            path: 'workinfo',
            icon: 'paperclip',
            name: 'workinfo',
            title: '劳务信息管理',
            component: () =>
                import('@/view/signOnMeet/workinfo.vue')
        },
        {
            path: 'otherList',
            icon: 'paperclip',
            name: 'otherList',
            title: '其他会务',
            component: () =>
                import('@/view/signOnMeet/otherList.vue')
        },
        {
            path: 'liveManage',
            icon: 'paperclip',
            name: 'liveManage',
            title: '会议管理',
            component: () =>
                import('@/view/signOnMeet/liveManage.vue'),
            meta: { keepAlive: true }
        },
        {
            path: 'liveOperate',
            icon: 'paperclip',
            name: 'liveOperate',
            title: '会议运营',
            component: () =>
                import('@/view/signOnMeet/liveOperate.vue'),
            meta: { keepAlive: true }
        },
        {
            path: 'livePlayer',
            icon: 'paperclip',
            name: 'livePlayer',
            title: '会议回放',
            component: () =>
                import('@/view/signOnMeet/livePlayer.vue')
        },{
            path: 'livebroadcast',
            icon: 'paperclip',
            name: 'livebroadcast',
            title: '预约会议',
            component: () => import('@/view/signOnMeet/livebroadcast.vue'),
            meta: { keepAlive: true }
        }
        ]
    },
    // {
    //     path: '/dataCenter',
    //     name: 'dataCenter',
    //     icon: 'folder',
    //     title: '数据中心',
    //     component: Main,
    //     children: [{
    //             path: 'committeeAnalysis',
    //             icon: 'paperclip',
    //             name: 'committeeAnalysis',
    //             title: '专业委员会分析',
    //             component: () =>
    //                 import ('@/view/dataCenter/committeeAnalysis.vue')
    //         },
    //         {
    //             path: 'menuAnalysis',
    //             icon: 'paperclip',
    //             name: 'menuAnalysis',
    //             title: '菜单分析',
    //             component: () =>
    //                 import ('@/view/dataCenter/menuAnalysis.vue')
    //         }
    //     ]
    // },
    {
        path: '/rightManage',
        name: 'rightManage',
        icon: 'folder',
        title: '权限管理',
        component: Main,
        children: [{
            path: 'right',
            icon: 'paperclip',
            name: 'right',
            title: '用户管理',
            component: () =>
                import('@/view/information/right.vue')
        },
        {
            path: 'group',
            icon: 'paperclip',
            name: 'group',
            title: '用户组管理',
            component: () =>
                import('@/view/information/group.vue')
        }
        ]
    },
    {
        path: '/Statistics',
        name: 'Statistics',
        icon: 'stats-bars',
        title: '统计管理',
        component: Main,
        children: [
            {
                path: 'paycostreport',
                icon: 'paperclip',
                name: 'paycostreport',
                title: '缴费报表统计',
                component: () =>
                    import('@/view/information/paycostreport.vue')
            },
            // {
            //     path: 'JobPerformance',
            //     icon: 'paperclip',
            //     name: 'JobPerformance',
            //     title: '学会工作统计',
            //     component: () => import('@/view/information/JobPerformance.vue')
            // },
            {
                path: 'PCAnalysis',
                icon: 'stats-bars',
                name: 'PCAnalysis',
                title: '专业委员会分析',
                component: () =>
                    import('@/view/Statistics/PCAnalysis.vue')
            },
            {
                path: 'contentmodule',
                icon: 'paperclip',
                name: 'contentmodule',
                title: '内容统计模块',
                component: () =>
                    import('@/view/Statistics/contentmodule.vue')
            },
            {
                path: 'BI',
                icon: 'paperclip',
                name: 'BI',
                title: '统计BI',
                component: () =>
                    import('@/view/Statistics/Bi.vue')
            },
            {
                path: 'BehaviorDetection',
                icon: 'paperclip',
                name: 'BehaviorDetection',
                title: '行为检测',
                component: () =>
                    import('@/view/Statistics/BehaviorDetection.vue')
            },
        ]
    }
];
export const AllRouter = [...homeRouter, ...appRouter];
